import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import { getMyRecord } from "@/api/overseasChinese/overseasChinese";
import myRecord from "./myRecord"; // import editComment from './editComment'

export default {
  name: "checkInRecord",
  components: {
    Sift: Sift,
    myRecord: myRecord
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      siftData: [{
        type: "bedate",
        key: "start,end",
        label: "上课时间",
        placeholder: "",
        defaultValue: "",
        indelible: true,
        fixed: true,
        pickerType: "datetime",
        // 传给时间组件的type = date、datetime
        sysDatasourceQuery: true,
        //传给时间组件是否需要自选格式
        optionalType: "yyyy-MM-dd HH:mm:ss" // 需要的时间格式

      }, {
        type: "select",
        key: "status",
        label: "签到状态",
        placeholder: "请选择签到状态",
        default: "",
        data: [{
          label: "正常",
          value: "1"
        }, {
          label: "迟到",
          value: "2"
        }, {
          label: "早退",
          value: "3"
        }, {
          label: "缺勤",
          value: "4"
        }]
      }, {
        type: "text",
        key: "name",
        label: "关键字",
        placeholder: "教室/课程/教师",
        default: ""
      }],
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10
      },
      total: 0,
      selectList: [],
      dialogVisible: false,
      editData: {
        state: false,
        data: {}
      } // mentData:{
      //     state: false,
      //     data:{}
      // }

    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
  },
  methods: {
    // setConment(row){
    //     this.mentData.state = true
    //     this.mentData.data = row
    // },
    seeInfo: function seeInfo(row) {
      this.editData.state = true;
      this.editData.data = row;
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this = this;

      this.loading = true;
      getMyRecord(this.paramSearch).then(function (res) {
        _this.loading = false;

        if (res.data.code == 0) {
          _this.list = res.data.data.records || [];
          _this.total = res.data.data.total;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.paramSearch = _objectSpread(_objectSpread(_objectSpread({}, this.paramSearch), this.$refs.needSift.getValue()), {}, {
        current: 1
      });
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectList = val.map(function (item) {
        return item.id;
      });
    }
  },
  watch: {},
  filters: {}
};